import * as tslib_1 from "tslib";
import { Base } from '../../components/base-component';
import './form-item-powerpulse.component.scss';
var FormItemPowerpulse = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemPowerpulse, _super);
    function FormItemPowerpulse(element) {
        return _super.call(this, element) || this;
    }
    FormItemPowerpulse.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.submitBtn = this.element.querySelector(".js-powerpulse__button");
    };
    FormItemPowerpulse.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.addEventListener("click", function (event) {
            var _button = event.target;
            var _form = _button.closest("form");
            var formFields = _form.querySelectorAll("input, select, textarea");
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        });
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pElement) {
                    pElement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (e) {
            _this.resetForm();
        }, false);
    };
    FormItemPowerpulse.prototype.submitForm = function (form) {
        var _this = this;
        // success screens
        var loader = form.querySelector(".form__loader--container");
        var thankYou = form.querySelector(".form__thankyou--container");
        var fieldsContainer = form.querySelector(".form__fields--container");
        // additional containers
        var success = form.querySelector(".form__success--container");
        var error = form.querySelector(".form__error--container");
        // hidden fields
        var description = form.querySelector("input[name=description]");
        var email = form.querySelector("input[name=email]");
        var recipient = form.querySelector("input[name=recipient]");
        var subject = form.querySelector("input[name=subject]");
        var product = form.querySelector("input[name=product]");
        // fields
        var firstname = this.form.querySelector("input[name=firstName]");
        var surname = this.form.querySelector("input[name=lastName]");
        var company = this.form.querySelector("input[name=companyName]");
        var contact = form.querySelector("input[name=phoneNumber]");
        var emailAddress = form.querySelector("input[name=emailAddress]");
        var assistance = form.querySelector("textarea[name=assistance]");
        var _postData = {
            'description': (description ? description.value : ""),
            'email': (email ? email.value : ""),
            'recipient': (recipient ? recipient.value : ""),
            'subject': (subject ? subject.value : ""),
            'product': (product ? product.value : ""),
            'firstname': (firstname ? firstname.value : ""),
            'surname': (surname ? surname.value : ""),
            'company': (company ? company.value : ""),
            'contact': (contact ? contact.value : ""),
            'emailAddress': (emailAddress ? emailAddress.value : ""),
            'assistance': (assistance ? assistance.value : ""),
            'source': this.formsService.isMobile()
        };
        // loader + hide form
        loader.classList.add("active");
        fieldsContainer.classList.add("hidden");
        // variables
        var url = "/leadsutils/powerpulse";
        // service
        this.formsService.postForm(url, this.http.serialiseObject(_postData)).then(function (response) {
            if (!response || !response.data) {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                loader.classList.remove("active");
                thankYou.classList.add("active");
                error.classList.add("active");
                success.classList.add("hidden");
            }
            else if (response.data.includes('invalid')) {
                _this.analyticsService.dtmRecordSiteError("noerrorcode|invalid fields|" + url);
                loader.classList.remove("active");
                thankYou.classList.add("active");
                error.classList.add("active");
                success.classList.add("hidden");
            }
            else {
                _this.analyticsService.dtmFormComplete("complete", response.code);
                loader.classList.remove("active");
                thankYou.classList.add("active");
                success.classList.add("active");
                error.classList.add("hidden");
            }
        }).catch(function (response) {
            // service failed
            _this.analyticsService.dtmRecordSiteError("noerrorcode|service failure occured|" + url);
            loader.classList.remove("active");
            thankYou.classList.add("active");
            error.classList.add("active");
            success.classList.add("hidden");
        });
    };
    FormItemPowerpulse.prototype.resetForm = function () {
        // success screens
        var loader = this.form.querySelector(".form__loader--container");
        var thankYou = this.form.querySelector(".form__thankyou--container");
        var fieldsContainer = this.form.querySelector(".form__fields--container");
        var success = this.form.querySelector(".form__success--container");
        var error = this.form.querySelector(".form__error--container");
        fieldsContainer.classList.remove("hidden");
        loader.classList.remove("active");
        thankYou.classList.remove("active");
        error.classList.remove("active");
        success.classList.remove("active");
        thankYou.classList.remove("hidden");
        error.classList.remove("hidden");
        success.classList.remove("hidden");
    };
    return FormItemPowerpulse;
}(Base));
export { FormItemPowerpulse };



//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/form-item-powerpulse/form-item-powerpulse.component.ts
// module id = 958
// module chunks = 0